import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { Link, StaticQuery, graphql } from 'gatsby'

import Header from './header'
import './layout.css'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Das Atelier Wasserhaus ist der Arbeitsort der bildenden Künstlerin Uschi Maurer in Eßfeld, Giebelstadt. Hier finden Sie Informationen, ausgewählte Werke und aktuelle Austellungstermine.' },
            { name: 'keywords', content: 'Uschi Maurer, Kurt Ewald, Giebelstadt, Eßfeld, Bronze, Keramik, Ausstellungen, Tierportraits, Künstler, Künstlerin' },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div
          style={{
            margin: '0 0 0 auto',
            maxWidth: 960,
          }}
        >
          {children}
        </div>
        <footer>
          <p>
            <Link to="/impressum/">Impressum</Link> · <Link to="/datenschutz/">Datenschutz</Link><br />
            &copy; 2019 Uschi Maurer
          </p>
        </footer>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
